import React, { memo } from 'react';

import HighlightColumn from '../Table/Decorator/HighlightColumn';
import Loading from '../../General/Loading';
import Table from '../Table/Table';
import ExtraInterest from '../InterestPerProduct/ExtraInterest';
import Messages from '../InterestPerProduct/Messages';

import InterestUri from '../../../Enum/InterestUri';

import getHighlightedColumnNumber from '../../../Reducer/GetHighlightedColumnNumber';
import useGetSort from '../../../Hook/Interest/UseGetSort';
import useGetInterestPerProduct from '../../../Hook/Interest/FetchTableData/UseGetInterestPerProduct';
import useIsFilterLoading from '../../../Hook/Interest/UseIsFilterLoading';
import useGetFilteredValues from '../../../Hook/Interest/UseGetFilteredValues';
import useGetLabels from '../../../Hook/Interest/UseGetLabels';

const InterestPerProductTable: React.FC = () => {
    const { constructionType, modificationLoanForm } = useGetFilteredValues();
    const isFilterLoading = useIsFilterLoading();

    const { activeLabel } = useGetLabels(true);

    const { error, data, headers, loading, extraInterest, messages } = useGetInterestPerProduct(
        constructionType,
        activeLabel,
        modificationLoanForm,
    );
    const currentSort = useGetSort(InterestUri.Product);

    if (activeLabel === null) {
        return <p className="no-results">Selecteer een hypotheeklabel om te beginnen.</p>;
    }

    if (isFilterLoading || loading) {
        return <Loading />;
    }

    if (error || !data.length || !headers.length) {
        return (
            <p className="no-results">
                Dit product heeft geen rentetarieven beschikbaar voor de gekozen aflossingsvorm i.c.m. woningsoort.
            </p>
        );
    }

    const highlightedColumnNO = getHighlightedColumnNumber(currentSort.prop, headers);
    return (
        <>
            {highlightedColumnNO > 0 && <HighlightColumn column={highlightedColumnNO} />}
            <Table
                className="interest-per-product"
                data={data}
                headers={headers}
                section={InterestUri.Product}
                sort={currentSort}
            />
            <ExtraInterest extraInterest={extraInterest} />
            <Messages messages={messages} />
        </>
    );
};

export default memo(InterestPerProductTable);
